const TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refreshToken';

export { TOKEN_KEY, REFRESH_TOKEN_KEY };
